import React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

function PrivacyPolicy() {
    return (
        <section>
            <Container className="px-0">
                <Row className="no-gutters">
                    <Col sm="12">
                        <div className="privacy-policy-wrapper my-5">
                            <div className="heading mb-4 text-uppercase text-center my-5">Privacy Policy</div>
                            <div className="sub-head fw-bold my-4">
                                Introduction
                            </div>
                            <p>
                                This Privacy Policy explains how we collect, use, and share information about users of our software and mobile application available through our website, Apple App Store, and Google Play Store. By using our site and app, you consent to our collection, use, and sharing of your information as described in this Privacy Policy.
                            </p>
                            <div className="sub-head fw-bold my-4">
                                Information We Collect:
                            </div>
                            <p>We may collect the following information about you when you use our app:</p>
                            <ul>
                                <li>
                                    Personal Information: We may collect your name, email address, phone number, and other personal information you provide when you register for our software and app, use our services, or contact us for support.</li>
                                <li>
                                    Usage Information: We may collect information about your usage of our software and app, such as the features you use, the pages you visit, the time and date of your visit, and your IP address. 
                                </li>
                                <li>
                                    Device Information: We may collect information about the device you use to access our software and app, such as the device type, operating system, and mobile network information.
                                </li>
                            </ul>
                            <div className="sub-head fw-bold my-4">
                                How We Use Your Information:
                            </div>
                            <p>We may use the information we collect for the following purposes:</p>
                            <ul>
                                <li>
                                    To provide our services to you and improve our software and app’s functionality.
                                </li>
                                <li>
                                    To communicate with you about our software and app, including sending you promotional materials and updates. 
                                </li>
                                <li>
                                    To personalize your experience with our software and app, including providing you with customized content. 
                                </li>
                                <li>
                                    To analyze and improve the effectiveness of our software and app, including troubleshooting problems and performing data analysis.
                                </li>
                            </ul>
                            <div className="sub-head fw-bold my-4">
                                How We Share Your Information:
                            </div>
                            <p>
                                We may share your information with third-party service providers who help us provide our software and app and services to you, such as analytics providers, email providers, and customer service providers.
                            </p>
                            <p>
                                We may also share your information if required by law or to protect our legal rights, such as in response to a court order or subpoena.
                            </p>
                            <p>
                                We will never sell your information to third parties for marketing purposes.
                            </p>
                            <div className="sub-head fw-bold my-4">
                                Your Choices:
                            </div>
                            <p>
                                You can opt-out of receiving promotional emails from us by following the instructions in the email or by contacting us at <a href="mailto:info@simplepermit.io">info@simplepermit.io</a>.
                            </p>
                            <p>
                                You can also adjust your device settings to limit our collection and use of your information. Please note that if you limit our collection and use of your information, some features of our software and app may not work correctly.
                            </p>
                            <div className="sub-head fw-bold my-4">
                                Data Retention:
                            </div>
                            <p>
                                We will retain your information for as long as necessary to provide our software and app and services to you, or as required by law.
                            </p>
                            <p>Security:</p>
                            <p>
                                We take reasonable measures to protect your information from unauthorized access, disclosure, or modification. However, no data transmission over the internet can be guaranteed to be completely secure. Therefore, we cannot guarantee the security of your information.
                            </p>
                            <div className="sub-head fw-bold my-4">
                                Security:
                            </div>
                            <p>
                                We take reasonable measures to protect your information from unauthorized access, disclosure, or modification. However, no data transmission over the internet can be guaranteed to be completely secure. Therefore, we cannot guarantee the security of your information.
                            </p>
                            <div className="sub-head fw-bold my-4">
                                Changes to this Privacy Policy:
                            </div>
                            <p>
                                We may update this Privacy Policy from time to time. If we make material changes, we will notify you by email or by posting a notice in our app. Your continued use of our software, website, and app after we make changes to this Privacy Policy will signify your acceptance of the new terms.
                            </p>
                            <div className="sub-head fw-bold my-4">
                                Contact Us:
                            </div>
                            <p>
                            If you have any questions or concerns about our Privacy Policy or our software, website, and app, please contact us at <a href="mailto:info@simplepermit.io" className="fw-bold">info@simplepermit.io</a>.
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default PrivacyPolicy;